<hlm-alert-dialog [state]="isOpen() ? 'open' : 'closed'" (stateChanged)="onStateChange($event)">
  <div hlmAlertDialogContent *brnAlertDialogContent="let ctx" class="w-3xl">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>Seleziona Azienda</h3>
      <p hlmAlertDialogDescription>Scegli l'azienda con cui vuoi lavorare</p>
    </div>

    <!-- Search Input -->
    <div>
      <div class="relative">
        <ng-icon
          name="lucideSearch"
          class="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground"
        />
        <input
          hlmInput
          type="text"
          class="h-11 w-full rounded-lg pl-11 pr-4 text-base"
          placeholder="Cerca azienda..."
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
        />
      </div>
    </div>

    <!-- Tenant List -->
    <div class="max-h-80 overflow-y-auto rounded-md border scrollbar-hide p-2">
      @if (filteredTenants().length === 0) {
        <div class="flex flex-col items-center justify-center py-8 text-muted-foreground">
          <ng-icon name="lucideBuilding2" class="mb-2 h-8 w-8" />
          <p class="text-sm">Nessuna azienda trovata</p>
        </div>
      } @else {
        <ul class="space-y-1">
          @for (tenant of filteredTenants(); track tenant.id) {
            <li>
              <button
                type="button"
                class="flex w-full items-center gap-3 rounded-md px-3 py-2 text-left transition-colors hover:bg-accent"
                [class.bg-accent]="isSelected(tenant)"
                (click)="selectTenant(tenant)"
              >
                <!-- Tenant Avatar -->
                <hlm-avatar class="h-9 w-9 shrink-0">
                  @if (tenant.logoS3Key) {
                    <img hlmAvatarImage [src]="tenant.logoS3Key" [alt]="tenant.businessName" />
                  }
                  <span hlmAvatarFallback class="bg-primary/10 text-primary text-sm font-medium">
                    {{ getTenantInitials(tenant) }}
                  </span>
                </hlm-avatar>

                <!-- Tenant Business Name -->
                <p class="min-w-0 flex-1 truncate text-sm font-medium text-foreground">
                  {{ tenant.businessName }}
                </p>

                <!-- Selected Indicator -->
                @if (isSelected(tenant)) {
                  <ng-icon name="lucideCheck" class="h-5 w-5 shrink-0 text-primary" />
                }
              </button>
            </li>
          }
        </ul>
      }
    </div>

    <div hlmAlertDialogFooter>
      <button hlmBtn variant="secondary" (click)="cancel()">Annulla</button>
    </div>
  </div>
</hlm-alert-dialog>
